import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

let blueprint = [
  {
    key: 'account',
    type: 'input',
    div: 3,
    disabled: true,
    required: true,
    label: '統一編號',
    placeholder: '請輸入統一編號',
    check (val) {
      if(!numberOnly(val)) return '只能包含數字';
    },
  },
  {
    key: 'name',
    type: 'input',
    div: 3,
    required: true,
    label: '公司名稱',
    placeholder: '請輸入公司名稱',
  },
  {
    key: 'en_name',
    type: 'input',
    div: 3,
    required: true,
    label: '英文名稱',
    placeholder: '請輸入英文名稱',
  },

  {
    key: 'principal',
    type: 'input',
    div: 4,
    required: true,
    label: '負責人',
    placeholder: '請輸入負責人',
  },
  {
    key: 'contact',
    type: 'input',
    div: 4,
    required: true,
    label: '聯絡人',
    placeholder: '請輸入聯絡人',
  },
  {
    key: 'job',
    type: 'input',
    div: 4,
    required: true,
    label: '職稱',
    placeholder: '請輸入職稱',
  },
  {
    key: 'phone',
    type: 'input',
    div: 4,
    required: true,
    label: '聯絡電話',
    placeholder: '請輸入聯絡電話',
  },

  {
    key: 'address',
    type: 'input',
    div: 3,
    required: true,
    label: '公司地址',
    placeholder: '請輸入公司地址',
  },
  {
    key: 'email',
    type: 'input',
    div: 3,
    required: true,
    label: 'E-mail',
    placeholder: '請輸入E-mail',
    check (val) {
      if(!isEmail(val)) return 'E-mail無效';
    },
  },
  {
    key: 'fax',
    type: 'input',
    div: 3,
    label: '傳真',
    placeholder: '請輸入傳真',
  },

  {
    key: 'turnover',
    type: 'number',
    div: 2,
    required: true,
    label: '年營業額',
    placeholder: '請輸入年營業額',
  },
  {
    key: 'staff_count',
    type: 'number',
    div: 2,
    required: true,
    label: '員工人數',
    placeholder: '請輸入員工人數',
  },

  {
    key: 'introduction',
    type: 'textarea',
    div: 2,
    required: true,
    label: '公司介紹',
    placeholder: '請輸入公司介紹',
    max_length: 500,
  },
  {
    key: 'vacation_way',
    type: 'textarea',
    div: 2,
    required: true,
    label: '休假/補休方式',
    placeholder: '請輸入休假/補休方式',
    max_length: 500,
  },

  {
    key: 'other_directions',
    type: 'textarea',
    div: 1,
    label: '其他說明',
    placeholder: '請輸入其他說明',
    max_length: 500,
  },
  { type: 'hr' },
  {
    key: 'expiry_date',
    type: 'output',
    div: 2,
    icon: 'end',
    label: '時間區間 (過期業界實習功能將自動關閉，需再次重新審核申請）',
    default: '-',
  },
];

export default blueprint;